if (!customElements.get('wbc-title-timeline')) {
    customElements.define('wbc-title-timeline', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
      }

      initialize() {
        this.rail = this.querySelector('[data-timeline-rail]');
        this.tabs = [...this.querySelectorAll('[data-timeline-tab]')];
        this.panels = [...this.querySelectorAll('[data-timeline-panel]')];
        if (!this.rail || !this.tabs.length || this.tabs.length !== this.panels.length) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.rail.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.select(index);
          }, options);
          tab.addEventListener('keydown', event => this.handleKey(event, index), options);
        });
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId || panel === event.target);
          if (index >= 0) this.select(index);
        }, options);
        this.setAttribute('data-enhanced', '');
        const fragmentIndex = this.panels.findIndex(panel => '#' + panel.id === window.location.hash);
        this.select(fragmentIndex >= 0 ? fragmentIndex : (this.selectedIndex || 0));
      }

      handleKey(event, index) {
        const rtl = getComputedStyle(this).direction === 'rtl';
        let next;
        if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (event.key === ' ' || event.key === 'Enter') next = index;
        if (next === undefined) return;
        event.preventDefault();
        next = (next + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus({ preventScroll: true });
      }

      select(index) {
        if (index < 0 || index >= this.tabs.length) return;
        this.selectedIndex = index;
        this.tabs.forEach((tab, position) => {
          const active = position === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[position].hidden = !active;
        });
      }
    });
  }
